import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RestRoutes } from '../_config/rest-routes.config';
import { Contact } from '../_models/contact.model';
import { SearchFilterDTO } from '../_models/search-filter-dto.model';

const API_URL = environment.urlPages;

@Injectable({
	providedIn: 'root',
})

export class ContactService {

	httpOptions = {
		headers: new HttpHeaders(
			{
				'Content-Type': 'application/json'
			}
		)
	};
	constructor(private http: HttpClient) { }

	getContact(parameters: any): Observable<Contact[]> {
		let query = new URLSearchParams(parameters).toString();
		let urlCommerces = `${environment.urlWS}${RestRoutes.CONTACTS}?${query}`;
		return this.http.get<Contact[]>(urlCommerces, this.httpOptions);
	}
}
